import React, { useState, useEffect } from "react";
import { Modal, Button } from 'react-bootstrap';
import APICom from '../../utils/helpers/APICom';

import { useSelector } from "react-redux";
// import Button from "../Controls/Button";

const UpdateCallback = (props) => {

    const [displayNoDataAlert, setDisplayNoDataAlert] = useState(false);
    const { GlobalASCSData}  = useSelector((store) => store.combinedata);
    const { loginData } = useSelector((store) => store.login);
    const [noDataAlert, setNoDataAlert] = useState({ alertTitle: '', alertMsg: '' });

    useEffect(() => {
        console.log("Update Callback invoked");
        if (props.GridRowData === null || props.GridRowData.length <= 0) {
            setNoDataAlert({ ...noDataAlert, alertTitle: 'No record is selected', alertMsg: 'Please select a valid record to update customer callback !'});
            setDisplayNoDataAlert(true);
        }
        else if (props.GridRowData.length > 1) {
            setNoDataAlert({ ...noDataAlert, alertTitle: 'Multiple trips selected', alertMsg: 'Please select one trip to update customer callback.' });
            setDisplayNoDataAlert(true);
        }
        else {
            handleUpdateCallbackCounter();

        }

    }, [props.GridRowData])

    const handleUpdateCallbackCounter = async (e) => {
        try {
            const gData = props.GridRowData[0];
            const data = {
                "confno": gData["ConfirmationNo"],
                "serviceid": gData["ServiceID"],
                "modifiedby": loginData.iUserID,
                "modifiedbyappid": "26",
                "datasource": gData["TableSource"],

            };
            let inloadurl = "";
                if (GlobalASCSData !== null && GlobalASCSData !== undefined) {
                    const jsonArray = GlobalASCSData;
                    const Marsinload = jsonArray.find(item => item.SubTitle === "InLoadAPI_URL");

                    if (Marsinload) {
                        inloadurl = Marsinload.value;
                    }
                }
            var response = await APICom.fetchData("full", `${inloadurl}/TripReservation/SendETACallNotificationToDriverOnCallBackAction
            `, "post", {}, data);
            setNoDataAlert({ ...noDataAlert, alertTitle: `Update Customer CallBack Counter`, alertMsg: 
                `Response Message: ${response.data === "Success" ? `CallBack Counter For Trip#: ${gData["ConfirmationNo"]} 
                Updated Successfully!` : "Unexpected Error Occured. Please Try Again Later"}` });
            setDisplayNoDataAlert(true);
        }
        catch (err) { console.log(err); }
    }

    const UnMountUpdateCallBackComponent = () => {
        if(props.showUpdateCallback)
          {
            props.setShowUpdateCallback(false);
            console.log("UpdateCallBack component Unmounted!");
          }
      }

    const handleAlertModalClose = () => {
        setDisplayNoDataAlert(false);
        UnMountUpdateCallBackComponent();


    }
   

    return (
        <>
            {displayNoDataAlert && <Modal centered show={displayNoDataAlert} onHide={handleAlertModalClose} animation={true} backdrop="static" keyboard={true}>
                <Modal.Header className='noshow_dialog_header_bgcolor' style={{ height: "50px" }} closeButton>
                    <Modal.Title className='noshow_dialog_title_color user-select-none'>{noDataAlert.alertTitle}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="user-select-none">
                    <b>{noDataAlert.alertMsg}</b>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleAlertModalClose}>
                        OK
                    </Button>
                </Modal.Footer>
            </Modal>}
        </>

    );
}

export default UpdateCallback;